/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

// Soft UI Dashboard PRO React helper functions
import rgba from "assets/theme/functions/rgba";
import pxToRem from "assets/theme/functions/pxToRem";

const { dark, transparent, white } = colors;

const divider = {
  styleOverrides: {
    root: {
      backgroundColor: "rgba(0, 0, 0, 0.12)", // Exact MUI v4 color
      backgroundImage: "none !important",     // Overrides any lingering template styles
      height: 1,                              // v4 uses height, not borders
      margin: 0,                              // v4 has 0 default margin
      border: "none",                         // Strips MUI v5 borders
      opacity: 1,

      "&.MuiDivider-vertical": {
        width: 1,
        height: "100%"
      },

      "&.MuiDivider-flexItem": {
        height: 'auto',
        alignSelf: 'stretch'
      }
    },

    vertical: {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      backgroundImage: "none !important",
      width: pxToRem(1),
      height: "100%",
      margin: `0 ${pxToRem(16)}`,
      border: "none",
    },

    light: {
      backgroundColor: "rgba(255, 255, 255, 0.12)", // v4 light/dark mode equivalent
      backgroundImage: "none !important",

      "&.MuiDivider-vertical": {
        backgroundImage: "none !important",
      }
    }
  }
};

export default divider;
